import * as React from "react"
import { cn } from "../../lib/utils"

const ButtonGroup = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
    return (
        <div
            ref={ref}
            className={cn(
                "inline-flex -space-x-px rounded-md border shadow-sm",
                "[&>button]:rounded-none [&>button]:shadow-none first:[&>button]:rounded-l-md last:[&>button]:rounded-r-md min-w-fit",
                "[&>button]:border-0 [&>button]:ring-0 [&>button]:focus:ring-0 [&>button]:focus:z-10",
                className
            )}
            {...props}
        />
    )
})
ButtonGroup.displayName = "ButtonGroup"

export { ButtonGroup }
export default ButtonGroup
